<template>
    <div class="hts-slide-over">
        <hts-drawer
            v-model="visible"
            :title="title"
            :describe="describe"
            :rules="rules"
            :size="width"
            :submit="submit"
            :close-hidden="closeHidden"
            @close="handleCloseClick"
            @show="handleDrawerShow"
            @visible="handleDrawerVisible"
            @reset="handleResetClick">
            <slot name="body" />
            <slot />
        </hts-drawer>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  width: {
    type: [String, Number]
  },
  title: String,
  describe: String,
  rules: {
    type: Object,
    default: () => {}
  },
  submit: Function,
  closeHidden: Boolean,
  resetEnable: Boolean
})
const { show } = toRefs(props)
const emits = defineEmits(['update:show', 'close', 'reset', 'visible', 'show'])
const visible = computed({
  get () {
    return show.value
  },
  set (val) {
    emits('update:show', val)
  }
})

const handleCloseClick = (e: any) => {
  emits('close', e)
}
const handleResetClick = (e: any) => {
  emits('reset', e)
}
const handleDrawerVisible = (e: any) => {
  emits('visible', e)
}
const handleDrawerShow = (e: any) => {
  emits('show', e)
}
</script>
